import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);
  const [services, setServices] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const openBooking = (serviceId = null) => {
    setPreselect(serviceId);
    setOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, preselect, openBooking, services, settings }}>
      {children}
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
